// ** Navigation sections imports
import apps from "./apps";
import links from "./links";

// ** Merge & Export
// export default [...dashboards, ...apps, ...pages, ...uiElements, ...forms, ...tables, ...chartsAndMaps, ...others]
export default [...apps, ...links];
    